import { NgModule } from '@angular/core';

import { ToastrModule } from 'ngx-toastr';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { PanelModule } from 'primeng/panel';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { ConfirmationService } from 'primeng/api';
import { ChartModule } from 'primeng/chart';
import { EditorModule } from 'primeng/editor';
import { TooltipModule } from 'primeng/tooltip';
import { KeyFilterModule } from 'primeng/keyfilter';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TreeTableModule } from 'primeng/treetable';
import { TreeModule } from 'primeng/tree';
import { DataViewModule } from 'primeng/dataview';
import { InputMaskModule } from 'primeng/inputmask';
import { ProgressBarModule } from 'primeng/progressbar';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { TabViewModule } from 'primeng/tabview';
import { CheckboxModule } from 'primeng/checkbox';
import { SelectButtonModule } from 'primeng/selectbutton';
import { InputSwitchModule } from 'primeng/inputswitch';
import { CarouselModule } from 'primeng/carousel';
import { SkeletonModule } from 'primeng/skeleton';
import { StepsModule } from 'primeng/steps';
import { RadioButtonModule } from 'primeng/radiobutton';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { AutosizeModule } from 'ngx-autosize';
import { NgJsonEditorModule } from 'ang-jsoneditor';
import { CookieService } from 'ngx-cookie-service';
import { RoundProgressModule } from 'angular-svg-round-progressbar';
import { EditorModule as EditorTinymceModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { MaskitoDirective } from '@maskito/angular';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';


// Localisation
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
registerLocaleData(localeFr);

// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/trads/', '.json');
}


const modules = [
  TableModule,
  ButtonModule,
  PanelModule,
  DynamicDialogModule,
  DropdownModule,
  CalendarModule,
  ConfirmDialogModule,
  DialogModule,
  ChartModule,
  EditorModule,
  TooltipModule,
  KeyFilterModule,
  InputMaskModule,
  ProgressBarModule,
  MessagesModule,
  MessageModule,
  OverlayPanelModule,
  TreeTableModule,
  TreeModule,
  DataViewModule,
  LoadingBarHttpClientModule,
  CheckboxModule,
  SelectButtonModule,
  InputSwitchModule,
  CarouselModule,
  SkeletonModule,
  StepsModule,
  RadioButtonModule,
  AutosizeModule,
  NgJsonEditorModule,
  TabViewModule,
  RoundProgressModule,
  EditorTinymceModule,
  MaskitoDirective  
];

@NgModule({
  declarations: [],
  imports: [
    ...modules,
    ToastrModule.forRoot({
      preventDuplicates: true
    }),
    PopoverModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    })
  ],
  exports: [...modules, ToastrModule, PopoverModule],
  // TinyMCE auto-hébergé (copié en /tinymce par angular.json) : sans ce jeton, l'éditeur se charge depuis Tiny Cloud
  providers: [DialogService, ConfirmationService, CookieService, { provide: TINYMCE_SCRIPT_SRC, useValue: '/tinymce/tinymce.min.js' }]
})
export class VendorsModule {}
